import { GAME_CONFIG } from '../config/GameConfig';
import { preloadAssets } from '../loaders/preloadAssets';

import {setTheGrid, getRandomType, getSafeRandomType, wouldCreateMatch, getWorldPosition, moveToGridPosition, moveItemTo, spawnReplacement,
applyGravity, spawnNewAtTop, spawnNewAtPosition, collapseGrid, refillGrid} from '../systems/BoardSystem';

import {checkMatches, handleMatches, showFloatingPoints, removeMatches, breakDonut} from '../systems/MatchSystem';
import {setupInput/*, handleSelection, clearSelection, getItemFromPointer, handleItemClick, areNeighbors*/} from '../systems/InputSystem';
import {startTimer, updateTimer, endGame} from '../systems/TimerSystem';
import {createScoreBoard} from '../ui/ScoreBoard';
import {createExitButton} from '../ui/ExitButton';
import {getRewardForScore, getRandomCatchphrase, showGameOverOverlay} from '../ui/GameOverOverlay';

import { createGameHeader } from '../ui/GameHeader';
import { createTimerDisplay, updateTimerDisplay } from '../ui/TimerDisplay';


export class Game extends Phaser.Scene {

    scoreText;

    score = 0;

    level = 0;

    limitedMoves = false;

    numberOfMoves = 10;

    numberOfMovesRemaining = 10;
    swapCount = 0;

    ///////////////////////////////////////////////////////////////////////////////////////////
    // here we'll have mostly settings that are configured through SMS

    disableInput = false;

    selectedItem = null;

    isSwapping = false;

    pointerDownItem = null;

    pointerStartX = 0;

    pointerStartY = 0;

    dragThreshold = 15;

    isDragging = false;

    lockedAxis = null; // 'x' or 'y'

    pendingEndGame = false;

    animationsRunning = 0;

    sparkleTextures = [];


    constructor() {
        super('Game');

        Object.assign(this, GAME_CONFIG);
    }


    // Phaser automatically calls init()
    // with the data from scene.start()

    init(data) {

        // Reset game state

        this.score = 0;

        this.swapCount = 0;
        this.numberOfMovesRemaining = this.numberOfMoves;

        this.pointerDownItem = null;

        this.selectedItem = null;

        this.isDragging = false;
        this.disableInput = false;

        this.isSwapping = false;

        this.items = [];

        this.grid = [];

        this.timerSeconds = 0;


        // configured from SMS

        if (data) {
            console.log(data);

            this.pointsRewardThreshold = data.pointsRewardThreshold || [
                {
                    requiredPoints: 500,
                    reward: 10
                }
            ];

            this.rewardedPointsName = data.rewardedPointsName;

            this.attempts = data.attempts || 1;
            this.userTimer = data.userTimer ?? true;
            //this.gameMode = this.userTimer ? 'timer' : 'moves';
            this.startTime = data.startTime || 20;
            this.remainingTime = this.startTime;
            this.limitedMoves = data.limitedMoves || false;
            this.numberOfMoves = data.numberOfMoves || 10;
            this.numberOfMovesRemaining = this.numberOfMoves;
            this.minimumLengthForPoints = data.minimumLengthForPoints || 3;
            this.minimumPointsGain = data.minimumPointsGain || 50;
            this.pointsMutiplier = data.pointsMutiplier || 15;
            this.bonusPointsMultiGroups = data.bonusPointsMultiGroups || 50;
            this.gamebackgroundColor = data.gamebackgroundColor || "#ffd96d";
            this.cellWidth = data.cellWidth || 48;
            this.cellHeight = data.cellHeight || 48;
            this.cols = data.cols || 5;
            this.rows = data.rows || 6;
        }


        this.onExit = data?.onExit;

        this.givePoints = data?.givePoints;
    }


    preload() {
        preloadAssets(this);
    }


    create() {
        /*
        this.sparkleTextures = [
            'sparkleWhite',
            'sparkleYellow',
            'sparklePink'
        ];


        this.cameras.main.setBackgroundColor(this.gamebackgroundColor);

        createScoreBoard(this);

        setTheGrid(this);

        createExitButton(this);
        */

        this.sparkleTextures = [
            'sparkleWhite',
            'sparkleYellow',
            'sparklePink'
        ];

        this.cameras.main.setBackgroundColor(
            this.gamebackgroundColor
        );

        // -----------------------------
        // PAGE 1 UI
        // -----------------------------

        createGameHeader(this);

        createScoreBoard(this);

        createExitButton(this);

        // -----------------------------
        // GAME BOARD
        // -----------------------------

        this.setTheGrid();

        // -----------------------------
        // TIMER UI
        // -----------------------------

        createTimerDisplay(this);

        this.startTimer();

        /*
        this.anims.create({
            key: 'sparkleAnim',
            frames: this.anims.generateFrameNumbers(
                'sparkle',
                {
                    start: 0,
                    end: 5
                }
            ),
            frameRate: 10,
            repeat: 0
        });
        */


        [
            'sparkleWhite',
            'sparkleYellow',
            'sparklePink'
        ].forEach(texture => {

            this.anims.create({
                key: `${texture}Anim`,
                frames:
                    this.anims.generateFrameNumbers(
                        texture,
                        {
                            start: 0,
                            end: 5
                        }
                    ),
                frameRate: 10,
                repeat: 0
            });

        });

        setupInput(this);
    }


    update() {

    }


    /*
    checkGameEnd() {

        console.log('checkGameEnd', 'moves=', this.swapCount, 'limit=', this.numberOfMoves, 'disableInput=', this.disableInput);

        if (this.disableInput) return;

        if (this.gameMode === 'moves') {

            if (this.swapCount >= this.numberOfMoves) {
                console.log('CALLING END GAME');

                console.log('pendingEndGame', this.pendingEndGame, 'animationsRunning', this.animationsRunning);


                // don't end immediately
                this.pendingEndGame = true;

                // wait until everything finishes
                if (this.animationsRunning <= 0) {
                    this.triggerEndGame();
                }
            }
        }
    }
    */

    checkGameEnd() {

        console.log(
            'checkGameEnd',
            'movesRemaining=',
            this.numberOfMovesRemaining,
            'limit=',
            this.numberOfMoves,
            'limitedMoves=',
            this.limitedMoves,
            'disableInput=',
            this.disableInput
        );

        if (this.disableInput) {
            return;
        }

        if (!this.limitedMoves) {
            return;
        }

        if (this.numberOfMovesRemaining <= 0) {

            console.log('CALLING END GAME');

            // If the game is also using a timer,
            // stop it immediately when all moves
            if (this.userTimer && this.timerEvent) {
                this.timerEvent.remove(false);
                this.timerEvent = null;
            }

            // Don't end immediately.
            this.pendingEndGame = true;

            // Wait until everything finishes.
            if (this.animationsRunning <= 0) {
                this.triggerEndGame();
            }
        }
    }


    startAnimation() {

        this.animationsRunning++;

        console.log('START',this.animationsRunning);
    }


    endAnimation() {

        this.animationsRunning--;

        console.log('END',this.animationsRunning);

        if (this.animationsRunning <= 0) {
            this.inputLocked = false;
        }
        

        if (this.animationsRunning <= 0 && this.pendingEndGame) {
            this.triggerEndGame();
        }
    }


    triggerEndGame() {
        if (this.disableInput) return;

        this.disableInput = true;

        this.timeUp();
    }


    timeUp() {

        //if (this.disableInput) return;

        this.disableInput = true;


        /*
        this.add.text(
            this.cameras.main.width / 2,
            this.cameras.main.height / 2,
            'TIME UP',
            {
                fontSize: '48px',
                color: '#ff0000'
            }
        ).setOrigin(0.5);
        */


        // Disable all donut interactions

        this.items.forEach(donut => {
            donut.disableInteractive();
        });


        //this.input.enabled = false;

        showGameOverOverlay(this);
    }


    swapItems(itemA, itemB, checkMatch = false, isRevert = false) {
        this.isSwapping = true;

        this.startAnimation();

        if (!isRevert) {
            this.swapCount++;
            if (this.limitedMoves) {
                this.numberOfMovesRemaining =
                    Math.max(
                        this.numberOfMovesRemaining - 1,
                        0
                    );
            }

            console.log(
                "Swaps:",
                this.swapCount,
                "Moves remaining:",
                this.numberOfMovesRemaining
            );

            this.updateTimerDisplay();
        }

        const colA = itemA.gridCol;
        const rowA = itemA.gridRow;

        const colB = itemB.gridCol;
        const rowB = itemB.gridRow;


        this.grid[rowA][colA] = itemB;

        this.grid[rowB][colB] = itemA;


        itemA.gridCol = colB;
        itemA.gridRow = rowB;


        itemB.gridCol = colA;
        itemB.gridRow = rowA;


        this.moveToGridPosition(itemA, true);

        this.moveToGridPosition(itemB, true);


        this.time.delayedCall(
            250,
            () => {

                if (checkMatch) {

                    const hadMatch =
                        this.checkMatches();

                    if (!hadMatch) {

                        this.swapItems(
                            itemA,
                            itemB,
                            false,
                            true
                        );

                        this.endAnimation();

                        return;
                    }
                }


                // --------------------------------------------------------
                // Always restore normal donut size after a completed swap
                // --------------------------------------------------------

                itemA.setDisplaySize(
                    this.cellWidth - 10,
                    this.cellHeight - 10
                );

                itemB.setDisplaySize(
                    this.cellWidth - 10,
                    this.cellHeight - 10
                );


                this.selectedItem = null;

                this.isSwapping = false;

                this.endAnimation();

                this.checkGameEnd();
            }
        );
    }


    // -------------------------------------------------------------------------
    // Delegated systems
    // -------------------------------------------------------------------------

    setTheGrid() {
        return setTheGrid(this);
    }


    getRandomType(excludeTexture = null) {
        return getRandomType(this, excludeTexture);
    }


    getSafeRandomType(col, row) {
        return getSafeRandomType(this, col, row);
    }


    wouldCreateMatch(col, row, type) {
        return wouldCreateMatch(this, col, row, type);
    }


    getWorldPosition(col, row) {
        return getWorldPosition(this, col, row);
    }


    moveToGridPosition(item, animate = true, delayIndex = 0) {
        return moveToGridPosition(this, item, animate, delayIndex);
    }


    moveItemTo(item, newCol, newRow) {
        return moveItemTo(this, item, newCol, newRow);
    }


    spawnReplacement(oldItem) {
        return spawnReplacement(this, oldItem);
    }


    applyGravity(col, removedRow) {
        return applyGravity(this, col, removedRow);
    }


    spawnNewAtTop(col) {
        return spawnNewAtTop(this,col);
    }


    spawnNewAtPosition(col, row) {

        return spawnNewAtPosition(this, col, row);
    }


    collapseGrid() {
        return collapseGrid(this);
    }


    refillGrid() {
        return refillGrid(this);
    }


    checkMatches() {
        return checkMatches(this);
    }


    handleMatches(matchGroups) {
        return handleMatches(this, matchGroups);
    }


    showFloatingPoints(group, points) {
        return showFloatingPoints(this, group, points);
    }


    removeMatches(matches, totalPoints) {
        return removeMatches(this, matches, totalPoints);
    }


    breakDonut(item, onComplete) {
        return breakDonut(this, item, onComplete);
    }


    setupInput() {
        return setupInput(this);
    }


    handleSelection(item) {
        return handleSelection(this, item);
    }


    clearSelection() {
        return clearSelection(this);
    }


    getItemFromPointer(pointer) {
        return getItemFromPointer(this, pointer);
    }


    handleItemClick(item) {
        return handleItemClick(this, item);
    }


    areNeighbors(a, b) {
        return areNeighbors(this, a, b);
    }


    startTimer() {
        return startTimer(this);
    }


    updateTimer() {
        return updateTimer(this);
    }


    updateTimerDisplay() {
        return updateTimerDisplay(this);
    }


    endGame() {
        return endGame(this);
    }


    getRewardForScore(score) {
        return getRewardForScore(this, score);
    }


    getRandomCatchphrase(reward) {
        return getRandomCatchphrase(this, reward);
    }


    showGameOverOverlay() {
        return showGameOverOverlay(this);
    }
}